import { render, staticRenderFns } from "./HousesView.vue?vue&type=template&id=9b51f036&scoped=true&"
import script from "./HousesView.vue?vue&type=script&lang=js&"
export * from "./HousesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b51f036",
  null
  
)

export default component.exports